<pre>{{ contents | json }}</pre>